var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    viewBox: "0 0 375 120",
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.707031 0 L 300.957031 0 L 300.957031 120 L 73.707031 120 Z M 73.707031 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 300.957031 60 C 300.957031 60.980469 300.910156 61.957031 300.820312 62.9375 C 300.730469 63.914062 300.59375 64.890625 300.410156 65.863281 C 300.226562 66.839844 300 67.808594 299.726562 68.777344 C 299.453125 69.746094 299.136719 70.710938 298.773438 71.671875 C 298.410156 72.632812 298.003906 73.585938 297.550781 74.535156 C 297.101562 75.488281 296.605469 76.429688 296.0625 77.367188 C 295.523438 78.304688 294.941406 79.234375 294.316406 80.15625 C 293.6875 81.078125 293.019531 81.992188 292.308594 82.894531 C 291.597656 83.800781 290.84375 84.695312 290.046875 85.578125 C 289.253906 86.464844 288.417969 87.339844 287.539062 88.203125 C 286.664062 89.066406 285.746094 89.917969 284.792969 90.757812 C 283.835938 91.597656 282.839844 92.425781 281.808594 93.238281 C 280.773438 94.054688 279.703125 94.851562 278.597656 95.640625 C 277.488281 96.425781 276.34375 97.199219 275.164062 97.953125 C 273.984375 98.710938 272.769531 99.453125 271.523438 100.179688 C 270.273438 100.902344 268.992188 101.613281 267.675781 102.304688 C 266.363281 102.996094 265.015625 103.671875 263.636719 104.328125 C 262.261719 104.988281 260.851562 105.625 259.414062 106.246094 C 257.976562 106.867188 256.511719 107.472656 255.019531 108.054688 C 253.523438 108.636719 252.003906 109.203125 250.457031 109.746094 C 248.914062 110.289062 247.339844 110.8125 245.746094 111.316406 C 244.152344 111.820312 242.535156 112.300781 240.894531 112.765625 C 239.253906 113.226562 237.59375 113.664062 235.914062 114.085938 C 234.230469 114.503906 232.53125 114.898438 230.8125 115.273438 C 229.097656 115.648438 227.363281 116 225.609375 116.332031 C 223.859375 116.660156 222.09375 116.96875 220.316406 117.253906 C 218.535156 117.535156 216.746094 117.796875 214.941406 118.035156 C 213.136719 118.273438 211.324219 118.488281 209.5 118.679688 C 207.675781 118.871094 205.84375 119.035156 204.003906 119.179688 C 202.164062 119.324219 200.320312 119.445312 198.46875 119.539062 C 196.617188 119.636719 194.765625 119.707031 192.90625 119.757812 C 191.050781 119.804688 189.191406 119.828125 187.332031 119.828125 C 185.472656 119.828125 183.613281 119.804688 181.757812 119.757812 C 179.898438 119.707031 178.046875 119.636719 176.195312 119.539062 C 174.34375 119.445312 172.5 119.324219 170.660156 119.179688 C 168.820312 119.035156 166.988281 118.871094 165.164062 118.679688 C 163.339844 118.488281 161.527344 118.273438 159.722656 118.035156 C 157.917969 117.796875 156.128906 117.535156 154.347656 117.253906 C 152.570312 116.96875 150.804688 116.660156 149.054688 116.332031 C 147.300781 116 145.566406 115.648438 143.847656 115.273438 C 142.132812 114.898438 140.433594 114.503906 138.75 114.085938 C 137.070312 113.664062 135.410156 113.226562 133.769531 112.765625 C 132.128906 112.300781 130.511719 111.820312 128.917969 111.316406 C 127.320312 110.8125 125.75 110.289062 124.207031 109.746094 C 122.660156 109.203125 121.140625 108.636719 119.644531 108.054688 C 118.152344 107.472656 116.6875 106.867188 115.25 106.246094 C 113.8125 105.625 112.402344 104.988281 111.027344 104.328125 C 109.648438 103.671875 108.300781 102.996094 106.988281 102.304688 C 105.671875 101.613281 104.390625 100.902344 103.140625 100.179688 C 101.890625 99.453125 100.679688 98.710938 99.5 97.953125 C 98.320312 97.199219 97.175781 96.425781 96.066406 95.640625 C 94.960938 94.851562 93.890625 94.054688 92.855469 93.238281 C 91.824219 92.425781 90.828125 91.597656 89.871094 90.757812 C 88.917969 89.917969 88 89.066406 87.125 88.203125 C 86.246094 87.339844 85.410156 86.464844 84.617188 85.578125 C 83.820312 84.695312 83.066406 83.800781 82.355469 82.894531 C 81.644531 81.992188 80.976562 81.078125 80.347656 80.15625 C 79.722656 79.234375 79.140625 78.304688 78.597656 77.367188 C 78.058594 76.429688 77.5625 75.488281 77.113281 74.535156 C 76.660156 73.585938 76.253906 72.632812 75.890625 71.671875 C 75.527344 70.710938 75.210938 69.746094 74.9375 68.777344 C 74.664062 67.808594 74.4375 66.839844 74.253906 65.863281 C 74.070312 64.890625 73.933594 63.914062 73.84375 62.9375 C 73.753906 61.957031 73.707031 60.980469 73.707031 60 C 73.707031 59.019531 73.753906 58.042969 73.84375 57.0625 C 73.933594 56.085938 74.070312 55.109375 74.253906 54.136719 C 74.4375 53.160156 74.664062 52.191406 74.9375 51.222656 C 75.210938 50.253906 75.527344 49.289062 75.890625 48.328125 C 76.253906 47.367188 76.660156 46.414062 77.113281 45.464844 C 77.5625 44.511719 78.058594 43.570312 78.597656 42.632812 C 79.140625 41.695312 79.722656 40.765625 80.347656 39.84375 C 80.976562 38.921875 81.644531 38.007812 82.355469 37.105469 C 83.066406 36.199219 83.820312 35.304688 84.617188 34.421875 C 85.410156 33.535156 86.246094 32.660156 87.125 31.796875 C 88 30.933594 88.917969 30.082031 89.871094 29.242188 C 90.828125 28.402344 91.824219 27.574219 92.855469 26.761719 C 93.890625 25.945312 94.960938 25.148438 96.066406 24.359375 C 97.175781 23.574219 98.320312 22.800781 99.5 22.046875 C 100.679688 21.289062 101.890625 20.546875 103.140625 19.820312 C 104.390625 19.097656 105.671875 18.386719 106.988281 17.695312 C 108.300781 17.003906 109.648438 16.328125 111.027344 15.671875 C 112.402344 15.011719 113.8125 14.375 115.25 13.753906 C 116.6875 13.132812 118.152344 12.527344 119.644531 11.945312 C 121.140625 11.363281 122.660156 10.796875 124.207031 10.253906 C 125.75 9.710938 127.320312 9.1875 128.917969 8.683594 C 130.511719 8.179688 132.128906 7.699219 133.769531 7.234375 C 135.410156 6.773438 137.070312 6.335938 138.75 5.914062 C 140.433594 5.496094 142.132812 5.101562 143.847656 4.726562 C 145.566406 4.351562 147.300781 4 149.054688 3.667969 C 150.804688 3.339844 152.570312 3.03125 154.347656 2.746094 C 156.128906 2.464844 157.917969 2.203125 159.722656 1.964844 C 161.527344 1.726562 163.339844 1.511719 165.164062 1.320312 C 166.988281 1.128906 168.820312 0.964844 170.660156 0.820312 C 172.5 0.675781 174.34375 0.554688 176.195312 0.460938 C 178.046875 0.363281 179.898438 0.292969 181.757812 0.242188 C 183.613281 0.195312 185.472656 0.171875 187.332031 0.171875 C 189.191406 0.171875 191.050781 0.195312 192.90625 0.242188 C 194.765625 0.292969 196.617188 0.363281 198.46875 0.460938 C 200.320312 0.554688 202.164062 0.675781 204.003906 0.820312 C 205.84375 0.964844 207.675781 1.128906 209.5 1.320312 C 211.324219 1.511719 213.136719 1.726562 214.941406 1.964844 C 216.746094 2.203125 218.535156 2.464844 220.316406 2.746094 C 222.09375 3.03125 223.859375 3.339844 225.609375 3.667969 C 227.363281 4 229.097656 4.351562 230.8125 4.726562 C 232.53125 5.101562 234.230469 5.496094 235.914062 5.914062 C 237.59375 6.335938 239.253906 6.773438 240.894531 7.234375 C 242.535156 7.699219 244.152344 8.179688 245.746094 8.683594 C 247.339844 9.1875 248.914062 9.710938 250.457031 10.253906 C 252.003906 10.796875 253.523438 11.363281 255.019531 11.945312 C 256.511719 12.527344 257.976562 13.132812 259.414062 13.753906 C 260.851562 14.375 262.261719 15.011719 263.636719 15.671875 C 265.015625 16.328125 266.363281 17.003906 267.675781 17.695312 C 268.992188 18.386719 270.273438 19.097656 271.523438 19.820312 C 272.769531 20.546875 273.984375 21.289062 275.164062 22.046875 C 276.34375 22.800781 277.488281 23.574219 278.597656 24.359375 C 279.703125 25.148438 280.773438 25.945312 281.808594 26.761719 C 282.839844 27.574219 283.835938 28.402344 284.792969 29.242188 C 285.746094 30.082031 286.664062 30.933594 287.539062 31.796875 C 288.417969 32.660156 289.253906 33.535156 290.046875 34.421875 C 290.84375 35.304688 291.597656 36.199219 292.308594 37.105469 C 293.019531 38.007812 293.6875 38.921875 294.316406 39.84375 C 294.941406 40.765625 295.523438 41.695312 296.0625 42.632812 C 296.605469 43.570312 297.101562 44.511719 297.550781 45.464844 C 298.003906 46.414062 298.410156 47.367188 298.773438 48.328125 C 299.136719 49.289062 299.453125 50.253906 299.726562 51.222656 C 300 52.191406 300.226562 53.160156 300.410156 54.136719 C 300.59375 55.109375 300.730469 56.085938 300.820312 57.0625 C 300.910156 58.042969 300.957031 59.019531 300.957031 60 Z M 300.957031 60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(.99928 0 0 1.00072 141.584 72.995)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    gradientUnits: "userSpaceOnUse",
    xlinkType: "simple",
    r: 149.326,
    xlinkActuate: "onLoad",
    cx: 0.344,
    id: "c",
    cy: -51.746,
    xlinkShow: "other",
    fx: 0.344,
    fy: -51.746
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF9FB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF7F9",
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF5F7",
    offset: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F6",
    offset: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F1F4",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8EFF2",
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EDF0",
    offset: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EBEE",
    offset: 0.027
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E9ED",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E8EB",
    offset: 0.035
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E6E9",
    offset: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E4E7",
    offset: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE2E5",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE0E4",
    offset: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECDEE2",
    offset: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDCE0",
    offset: 0.059
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9DADE",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D8DC",
    offset: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D6DB",
    offset: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5D4D9",
    offset: 0.074
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4D2D7",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3D0D5",
    offset: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1CED4",
    offset: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0CCD2",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFCAD0",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDC9CE",
    offset: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCC7CC",
    offset: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC5CB",
    offset: 0.105
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9C3C9",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8C1C7",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7BFC5",
    offset: 0.117
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5BDC3",
    offset: 0.121
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4BBC2",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3B9C0",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1B7BE",
    offset: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0B5BC",
    offset: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB3BA",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB1B9",
    offset: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCAFB7",
    offset: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADB5",
    offset: 0.152
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAABB3",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8AAB1",
    offset: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7A8B0",
    offset: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A6AE",
    offset: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A4AC",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A2AA",
    offset: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2A0A8",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C09EA7",
    offset: 0.184
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9CA5",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9AA3",
    offset: 0.191
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC98A1",
    offset: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB969F",
    offset: 0.199
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA949E",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8929C",
    offset: 0.207
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7909A",
    offset: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68E98",
    offset: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B48C96",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B38B95",
    offset: 0.223
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28993",
    offset: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B08791",
    offset: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF858F",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE838D",
    offset: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC818C",
    offset: 0.242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB7F8A",
    offset: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7D88",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87B86",
    offset: 0.254
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77984",
    offset: 0.258
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A67783",
    offset: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57581",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3737F",
    offset: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2717D",
    offset: 0.273
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16F7B",
    offset: 0.277
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F6E7A",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6C78",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D6A76",
    offset: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B6874",
    offset: 0.293
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6672",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996471",
    offset: 0.301
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97626F",
    offset: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96606D",
    offset: 0.309
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955E6B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#935C69",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#925A68",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#915866",
    offset: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5664",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E5462",
    offset: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D5261",
    offset: 0.336
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B505F",
    offset: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4F5D",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#894D5B",
    offset: 0.348
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#874B59",
    offset: 0.352
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#864958",
    offset: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#854756",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#834554",
    offset: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824352",
    offset: 0.367
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#814150",
    offset: 0.371
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#803F4F",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E3D4D",
    offset: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3B4B",
    offset: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C3949",
    offset: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A3747",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793546",
    offset: 0.395
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#783344",
    offset: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#763142",
    offset: 0.402
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753040",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#742E3E",
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#722C3D",
    offset: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#712A3B",
    offset: 0.418
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#702839",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2637",
    offset: 0.426
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2435",
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2234",
    offset: 0.434
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2032",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#691E30",
    offset: 0.441
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#681C2E",
    offset: 0.445
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#661A2C",
    offset: 0.449
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65182B",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#641629",
    offset: 0.457
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621427",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#611225",
    offset: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#601123",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F0F22",
    offset: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0D20",
    offset: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C0B1E",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B091C",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59071A",
    offset: 0.488
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580519",
    offset: 0.492
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#570317",
    offset: 0.496
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#560216",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550317",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550418",
    offset: 0.527
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550418",
    offset: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550519",
    offset: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#540519",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54061A",
    offset: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54061B",
    offset: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54071B",
    offset: 0.598
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53081C",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53081C",
    offset: 0.621
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53091D",
    offset: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#520A1E",
    offset: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#520B1F",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#520C20",
    offset: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#510C21",
    offset: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#510D21",
    offset: 0.723
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#510E22",
    offset: 0.738
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#500E23",
    offset: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#500F23",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#501024",
    offset: 0.777
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F1025",
    offset: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F1125",
    offset: 0.801
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F1126",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F1227",
    offset: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E1328",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E1428",
    offset: 0.863
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D1429",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D152A",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D162A",
    offset: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D162B",
    offset: 0.914
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C172C",
    offset: 0.934
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C182D",
    offset: 0.949
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C192D",
    offset: 0.961
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7a1f4f",
    offset: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7a1f4f",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M 73.707031 0.171875 L 73.707031 119.828125 L 300.957031 119.828125 L 300.957031 0.171875 Z M 73.707031 0.171875"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 296.519531 60 C 296.519531 60.90625 296.472656 61.8125 296.386719 62.71875 C 296.300781 63.621094 296.167969 64.527344 295.992188 65.429688 C 295.816406 66.332031 295.597656 67.230469 295.335938 68.125 C 295.074219 69.023438 294.769531 69.914062 294.421875 70.804688 C 294.070312 71.695312 293.679688 72.578125 293.246094 73.457031 C 292.8125 74.335938 292.335938 75.210938 291.816406 76.078125 C 291.296875 76.945312 290.738281 77.804688 290.136719 78.65625 C 289.535156 79.511719 288.890625 80.355469 288.207031 81.195312 C 287.523438 82.03125 286.800781 82.859375 286.035156 83.679688 C 285.269531 84.5 284.46875 85.308594 283.625 86.109375 C 282.785156 86.90625 281.902344 87.695312 280.984375 88.472656 C 280.066406 89.25 279.109375 90.015625 278.117188 90.769531 C 277.125 91.523438 276.097656 92.265625 275.03125 92.992188 C 273.96875 93.71875 272.867188 94.433594 271.734375 95.136719 C 270.601562 95.835938 269.433594 96.523438 268.234375 97.191406 C 267.035156 97.863281 265.800781 98.519531 264.539062 99.160156 C 263.273438 99.804688 261.980469 100.425781 260.65625 101.035156 C 259.332031 101.644531 257.980469 102.238281 256.597656 102.8125 C 255.21875 103.386719 253.808594 103.945312 252.375 104.484375 C 250.9375 105.023438 249.476562 105.546875 247.992188 106.050781 C 246.507812 106.554688 244.996094 107.039062 243.464844 107.503906 C 241.933594 107.96875 240.378906 108.417969 238.800781 108.84375 C 237.226562 109.269531 235.628906 109.679688 234.015625 110.066406 C 232.398438 110.453125 230.765625 110.820312 229.117188 111.167969 C 227.464844 111.515625 225.796875 111.839844 224.117188 112.144531 C 222.433594 112.449219 220.738281 112.734375 219.027344 113 C 217.316406 113.261719 215.59375 113.503906 213.863281 113.722656 C 212.128906 113.945312 210.386719 114.140625 208.632812 114.320312 C 206.878906 114.496094 205.121094 114.652344 203.351562 114.785156 C 201.585938 114.917969 199.8125 115.027344 198.035156 115.117188 C 196.253906 115.207031 194.472656 115.273438 192.6875 115.316406 C 190.90625 115.359375 189.117188 115.382812 187.332031 115.382812 C 185.546875 115.382812 183.757812 115.359375 181.972656 115.316406 C 180.191406 115.273438 178.40625 115.207031 176.628906 115.117188 C 174.851562 115.027344 173.078125 114.917969 171.3125 114.785156 C 169.542969 114.652344 167.785156 114.496094 166.03125 114.320312 C 164.277344 114.140625 162.535156 113.945312 160.800781 113.722656 C 159.066406 113.503906 157.347656 113.261719 155.636719 113 C 153.925781 112.734375 152.230469 112.449219 150.546875 112.144531 C 148.867188 111.839844 147.199219 111.515625 145.546875 111.167969 C 143.898438 110.820312 142.265625 110.453125 140.648438 110.066406 C 139.035156 109.679688 137.4375 109.269531 135.863281 108.84375 C 134.285156 108.417969 132.730469 107.96875 131.199219 107.503906 C 129.667969 107.039062 128.15625 106.554688 126.671875 106.050781 C 125.183594 105.546875 123.726562 105.023438 122.289062 104.484375 C 120.855469 103.945312 119.445312 103.386719 118.066406 102.8125 C 116.683594 102.238281 115.332031 101.644531 114.007812 101.035156 C 112.683594 100.425781 111.390625 99.804688 110.125 99.160156 C 108.863281 98.519531 107.628906 97.863281 106.429688 97.191406 C 105.230469 96.523438 104.0625 95.835938 102.929688 95.132812 C 101.796875 94.433594 100.695312 93.71875 99.632812 92.992188 C 98.566406 92.265625 97.539062 91.523438 96.546875 90.769531 C 95.554688 90.015625 94.597656 89.25 93.679688 88.472656 C 92.761719 87.695312 91.878906 86.90625 91.039062 86.109375 C 90.195312 85.308594 89.390625 84.5 88.628906 83.679688 C 87.863281 82.859375 87.140625 82.03125 86.457031 81.195312 C 85.773438 80.355469 85.128906 79.511719 84.527344 78.65625 C 83.925781 77.804688 83.367188 76.945312 82.847656 76.078125 C 82.328125 75.210938 81.851562 74.335938 81.417969 73.457031 C 80.984375 72.578125 80.59375 71.695312 80.242188 70.804688 C 79.894531 69.914062 79.589844 69.023438 79.328125 68.125 C 79.066406 67.230469 78.847656 66.332031 78.671875 65.429688 C 78.496094 64.527344 78.363281 63.621094 78.277344 62.71875 C 78.1875 61.8125 78.144531 60.90625 78.144531 60 C 78.144531 59.09375 78.1875 58.1875 78.277344 57.28125 C 78.363281 56.378906 78.496094 55.472656 78.671875 54.570312 C 78.847656 53.667969 79.066406 52.769531 79.328125 51.875 C 79.589844 50.976562 79.894531 50.085938 80.242188 49.195312 C 80.59375 48.304688 80.984375 47.421875 81.417969 46.542969 C 81.851562 45.664062 82.328125 44.789062 82.847656 43.921875 C 83.367188 43.054688 83.925781 42.195312 84.527344 41.34375 C 85.128906 40.488281 85.773438 39.644531 86.457031 38.804688 C 87.140625 37.96875 87.863281 37.140625 88.628906 36.320312 C 89.390625 35.5 90.195312 34.691406 91.039062 33.890625 C 91.878906 33.09375 92.761719 32.304688 93.679688 31.527344 C 94.597656 30.75 95.554688 29.984375 96.546875 29.230469 C 97.539062 28.476562 98.566406 27.734375 99.632812 27.007812 C 100.695312 26.28125 101.796875 25.566406 102.929688 24.863281 C 104.0625 24.164062 105.230469 23.476562 106.429688 22.808594 C 107.628906 22.136719 108.863281 21.480469 110.125 20.839844 C 111.390625 20.195312 112.683594 19.574219 114.007812 18.964844 C 115.332031 18.355469 116.683594 17.761719 118.066406 17.1875 C 119.445312 16.613281 120.855469 16.054688 122.289062 15.515625 C 123.726562 14.976562 125.183594 14.453125 126.671875 13.949219 C 128.15625 13.445312 129.667969 12.960938 131.199219 12.496094 C 132.730469 12.03125 134.285156 11.582031 135.863281 11.15625 C 137.4375 10.730469 139.035156 10.320312 140.648438 9.933594 C 142.265625 9.546875 143.898438 9.179688 145.546875 8.832031 C 147.199219 8.484375 148.867188 8.160156 150.546875 7.855469 C 152.230469 7.550781 153.925781 7.265625 155.636719 7 C 157.347656 6.738281 159.066406 6.496094 160.800781 6.277344 C 162.535156 6.054688 164.277344 5.859375 166.03125 5.679688 C 167.785156 5.503906 169.542969 5.347656 171.3125 5.214844 C 173.078125 5.082031 174.851562 4.972656 176.628906 4.882812 C 178.40625 4.792969 180.191406 4.726562 181.972656 4.683594 C 183.757812 4.640625 185.546875 4.617188 187.332031 4.617188 C 189.117188 4.617188 190.90625 4.640625 192.6875 4.683594 C 194.472656 4.726562 196.253906 4.792969 198.035156 4.882812 C 199.8125 4.972656 201.585938 5.082031 203.351562 5.214844 C 205.121094 5.347656 206.878906 5.503906 208.632812 5.679688 C 210.386719 5.859375 212.128906 6.054688 213.863281 6.277344 C 215.59375 6.496094 217.316406 6.738281 219.027344 7 C 220.738281 7.265625 222.433594 7.550781 224.117188 7.855469 C 225.796875 8.160156 227.464844 8.484375 229.117188 8.832031 C 230.765625 9.179688 232.398438 9.546875 234.015625 9.933594 C 235.628906 10.320312 237.226562 10.730469 238.800781 11.15625 C 240.378906 11.582031 241.933594 12.03125 243.464844 12.496094 C 244.996094 12.960938 246.507812 13.445312 247.992188 13.949219 C 249.476562 14.453125 250.9375 14.976562 252.375 15.515625 C 253.808594 16.054688 255.21875 16.613281 256.597656 17.1875 C 257.980469 17.761719 259.332031 18.355469 260.65625 18.964844 C 261.980469 19.574219 263.273438 20.195312 264.539062 20.839844 C 265.800781 21.480469 267.035156 22.136719 268.234375 22.808594 C 269.433594 23.476562 270.601562 24.164062 271.734375 24.863281 C 272.867188 25.566406 273.96875 26.28125 275.03125 27.007812 C 276.097656 27.734375 277.125 28.476562 278.117188 29.230469 C 279.109375 29.984375 280.066406 30.75 280.984375 31.527344 C 281.902344 32.304688 282.785156 33.09375 283.625 33.890625 C 284.46875 34.691406 285.269531 35.5 286.035156 36.320312 C 286.800781 37.140625 287.523438 37.96875 288.207031 38.804688 C 288.890625 39.644531 289.535156 40.488281 290.136719 41.34375 C 290.738281 42.195312 291.296875 43.054688 291.816406 43.921875 C 292.335938 44.789062 292.8125 45.664062 293.246094 46.542969 C 293.679688 47.421875 294.070312 48.304688 294.421875 49.195312 C 294.769531 50.085938 295.074219 50.976562 295.335938 51.875 C 295.597656 52.769531 295.816406 53.667969 295.992188 54.570312 C 296.167969 55.472656 296.300781 56.378906 296.386719 57.28125 C 296.472656 58.1875 296.519531 59.09375 296.519531 60 Z M 296.519531 60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAFC",
    d: "M 209.433594 77.957031 L 214.851562 50.042969 C 216.09375 43.730469 215.027344 39.019531 211.832031 36.085938 C 208.726562 33.242188 203.398438 31.820312 195.585938 31.820312 L 186.179688 31.820312 L 188.839844 17.953125 C 188.929688 17.417969 188.839844 16.882812 188.484375 16.441406 C 188.128906 15.996094 187.6875 15.816406 187.15625 15.816406 L 174.195312 15.816406 C 173.304688 15.816406 172.597656 16.441406 172.417969 17.238281 L 166.648438 46.84375 C 166.117188 43.464844 164.875 40.621094 162.742188 38.308594 C 158.925781 33.953125 152.976562 31.730469 144.898438 31.730469 L 119.957031 31.730469 C 119.066406 31.730469 118.359375 32.351562 118.179688 33.152344 L 106.550781 93.246094 C 106.460938 93.78125 106.550781 94.316406 106.90625 94.757812 C 107.261719 95.203125 107.707031 95.382812 108.238281 95.382812 L 121.289062 95.382812 C 122.175781 95.382812 122.886719 94.757812 123.0625 93.957031 L 125.902344 79.46875 L 135.578125 79.46875 C 140.640625 79.46875 144.988281 78.933594 148.273438 77.867188 C 151.734375 76.710938 154.84375 74.847656 157.59375 72.269531 C 159.8125 70.222656 161.675781 67.910156 163.097656 65.421875 L 160.789062 77.425781 C 160.699219 77.957031 160.789062 78.492188 161.144531 78.933594 C 161.5 79.378906 161.945312 79.558594 162.476562 79.558594 L 175.4375 79.558594 C 176.324219 79.558594 177.035156 78.933594 177.210938 78.136719 L 183.605469 45.242188 L 192.480469 45.242188 C 196.296875 45.242188 197.363281 45.953125 197.71875 46.308594 C 197.984375 46.578125 198.515625 47.644531 197.894531 50.933594 L 192.746094 77.511719 C 192.65625 78.046875 192.746094 78.578125 193.101562 79.023438 C 193.457031 79.46875 193.902344 79.644531 194.433594 79.644531 L 207.75 79.644531 C 208.546875 79.378906 209.257812 78.757812 209.433594 77.957031 Z M 149.425781 54.84375 C 148.628906 59.023438 147.121094 62.042969 144.898438 63.734375 C 142.679688 65.421875 139.042969 66.3125 134.246094 66.3125 L 128.476562 66.3125 L 132.648438 44.796875 L 140.105469 44.796875 C 145.609375 44.796875 147.828125 45.953125 148.71875 46.933594 C 149.871094 48.355469 150.136719 51.109375 149.425781 54.84375 Z M 149.425781 54.84375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAFC",
    d: "M 264.828125 38.308594 C 261.011719 33.953125 255.0625 31.730469 246.984375 31.730469 L 221.863281 31.730469 C 220.976562 31.730469 220.265625 32.351562 220.085938 33.152344 L 208.460938 93.160156 C 208.371094 93.691406 208.460938 94.226562 208.8125 94.671875 C 209.167969 95.113281 209.613281 95.292969 210.144531 95.292969 L 223.195312 95.292969 C 224.082031 95.292969 224.792969 94.671875 224.96875 93.871094 L 227.8125 79.378906 L 237.488281 79.378906 C 242.546875 79.378906 246.894531 78.847656 250.179688 77.78125 C 253.644531 76.625 256.75 74.757812 259.5 72.179688 C 261.808594 70.046875 263.761719 67.644531 265.183594 65.066406 C 266.601562 62.488281 267.667969 59.644531 268.289062 56.53125 C 269.796875 48.800781 268.644531 42.753906 264.828125 38.308594 Z M 251.246094 54.84375 C 250.445312 59.023438 248.9375 62.042969 246.71875 63.734375 C 244.5 65.421875 240.859375 66.3125 236.066406 66.3125 L 230.296875 66.3125 L 234.46875 44.796875 L 241.925781 44.796875 C 247.429688 44.796875 249.648438 45.953125 250.535156 46.933594 C 251.777344 48.355469 252.042969 51.109375 251.246094 54.84375 Z M 251.246094 54.84375"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 140.105469 43.019531 C 145.078125 43.019531 148.363281 43.910156 150.046875 45.777344 C 151.734375 47.644531 152.089844 50.753906 151.203125 55.199219 C 150.316406 59.820312 148.539062 63.199219 145.964844 65.15625 C 143.390625 67.113281 139.484375 68.089844 134.246094 68.089844 L 126.347656 68.089844 L 131.230469 43.019531 Z M 108.328125 93.515625 L 121.375 93.515625 L 124.484375 77.601562 L 135.667969 77.601562 C 140.640625 77.601562 144.632812 77.066406 147.828125 76 C 151.023438 74.933594 153.867188 73.246094 156.527344 70.757812 C 158.75 68.710938 160.523438 66.488281 161.855469 64.089844 C 163.1875 61.6875 164.164062 59.023438 164.695312 56.089844 C 166.117188 48.976562 165.050781 43.464844 161.589844 39.464844 C 158.125 35.464844 152.621094 33.507812 145.078125 33.507812 L 119.957031 33.507812 Z M 108.328125 93.515625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 174.28125 17.597656 L 187.242188 17.597656 L 184.136719 33.507812 L 195.675781 33.507812 C 202.957031 33.507812 207.925781 34.753906 210.679688 37.332031 C 213.429688 39.910156 214.230469 44 213.164062 49.6875 L 207.75 77.601562 L 194.609375 77.601562 L 199.757812 51.019531 C 200.382812 48 200.113281 45.953125 199.136719 44.886719 C 198.160156 43.820312 195.941406 43.199219 192.65625 43.199219 L 182.273438 43.199219 L 175.613281 77.601562 L 162.652344 77.601562 Z M 174.28125 17.597656"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 241.925781 43.019531 C 246.894531 43.019531 250.179688 43.910156 251.867188 45.777344 C 253.554688 47.644531 253.910156 50.753906 253.019531 55.199219 C 252.132812 59.820312 250.359375 63.199219 247.785156 65.15625 C 245.210938 67.113281 241.304688 68.089844 236.066406 68.089844 L 228.164062 68.089844 L 233.046875 43.019531 Z M 210.144531 93.515625 L 223.195312 93.515625 L 226.300781 77.601562 L 237.488281 77.601562 C 242.457031 77.601562 246.453125 77.066406 249.648438 76 C 252.84375 74.933594 255.683594 73.246094 258.347656 70.757812 C 260.566406 68.710938 262.34375 66.488281 263.671875 64.089844 C 265.003906 61.6875 265.980469 59.023438 266.515625 56.089844 C 267.933594 48.976562 266.871094 43.464844 263.40625 39.464844 C 259.945312 35.464844 254.441406 33.507812 246.894531 33.507812 L 221.773438 33.507812 Z M 210.144531 93.515625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.c1dbdd06351ac5b6f385ead9c56345c5.svg";
export { ForwardRef as ReactComponent };